export const EDITOR_MODULES = [['bold', 'italic'], ['link'], [{ align: [] }]] as const;
export const EDITOR_FORMATS: string[] = ['bold', 'italic', 'link', 'align'];

// Affiliate link for Rent the Runway wedding guest dresses provided by the business
export const AFFILIATE_RENT_THE_RUNWAY_URL =
  'https://www.pjatr.com/t/8-12557-88550-223734?sid=Theknot.com-wedding-website-guest-fashion&website=177979&url=https%3A%2F%2Fwww.renttherunway.com%2Fc%2Fwedding-guest-dresses';

export const DEFAULT_AFFILIATE_IMAGE_ID = '3fa85f64-5717-4562-b3fc-2c963f66af29';

// Simple label mapping for tracking purposes (camelCase only)
const ATTIRE_CATEGORY_LABELS: Record<string, string> = {
  casual: 'Casual',
  semiFormal: 'Semi-formal',
  cocktail: 'Cocktail',
  formal: 'Formal',
  blackTie: 'Black-tie',
  whiteTie: 'White-tie',
  other: 'Other',
};

// Tracking helper functions for dress code items only
export const getDressCodeTypeLabel = (attireCategoryId?: string | null): string => {
  if (!attireCategoryId) return '';
  return ATTIRE_CATEGORY_LABELS[attireCategoryId] || attireCategoryId;
};

export interface DressCodeItemTracking {
  showArticles?: boolean | null;
  showAffiliates?: boolean | null;
  attireCategoryId?: string | null;
}

export const getDressCodeTrackingProperties = (
  dressCodeItem: DressCodeItemTracking | undefined | null
): { showArticles: boolean; showAffiliates: boolean; attireCategoryId: string } => {
  return {
    showArticles: dressCodeItem?.showArticles ?? true,
    showAffiliates: dressCodeItem?.showAffiliates ?? true,
    attireCategoryId: getDressCodeTypeLabel(dressCodeItem?.attireCategoryId ?? null),
  };
};
